import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    wrapper: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      flex: 1,
      [theme.breakpoints.up('md')]: {
        alignItems: 'flex-start',
      },
    },
  });
});

export default useStyles;
